<template>
  <div
    v-if="currentUser.attributes"
    ref="el"
    :class="['profileMenuContainer', { expanded }]"
  >
    <div class="navbar__item__link">
      <span class="navbar__item__link--container">
        <ProfilePhoto :url="currentUser.attributes.avatar" />
      </span>
    </div>
    <ProfileMenuBody
      :expanded="expanded"
      :show="showProfile"
      :show-accounts="showAccounts"
      @logout="handleLogout"
      @setShowAccounts="setShowAccounts"
      @toggleProfile="toggleProfile"
    />
    <ProfileMenuAccountList
      :show-accounts="showProfile && showAccounts"
      @setShowAccounts="setShowAccounts"
    />
  </div>
</template>
<script setup>
import ProfileMenuAccountList from '@/components/navbar/ProfileMenuAccountList'
import ProfileMenuBody from '@/components/navbar/ProfileMenuBody'
import ProfilePhoto from '@/components/shared/ProfilePhoto'
import { computed, onBeforeUnmount, onMounted, ref } from 'vue'
import { useStore } from 'vuex'

const store = useStore()

const props = defineProps({
  showProfile: {
    type: Boolean,
    default: false
  },
  expanded: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['toggleProfile', 'logout'])

const el = ref(null)
const showAccounts = ref(false)
const currentUser = computed(() => store.state.workspace.currentUser)

onMounted(() => {
  document.addEventListener('click', close)
})

onBeforeUnmount(() => {
  document.removeEventListener('click', close)
})

function handleLogout() {
  emit('logout')
}
function toggleProfile() {
  emit('toggleProfile')
}
function close(e) {
  if (!el.value.contains(e.target) && props.showProfile) {
    toggleProfile()
    showAccounts.value = false
  }
}
function setShowAccounts(show) {
  showAccounts.value = show
}
</script>
<style lang="scss">
.profileMenuContainer {
  .profilePhoto {
    border: 2px solid $blue-80;
    cursor: pointer;
  }
  .accountList {
    position: absolute;
    bottom: 175px;
    left: 380px;
    min-width: 250px;
    max-height: 500px;
  }
  &.expanded {
    .accountList {
      left: 570px;
    }
  }
}
</style>
